/**
 * Stockholm stadsdel hub FAQ copy for brukare/family provider-choice SEO.
 * Answers stay geo-scoped to Stockholms stad — not national Guide essays.
 */

export type DistrictFaqItem = {
  question: string;
  answer: string;
};

/**
 * Build 4–5 FAQ items for a named Stockholm district hub.
 * @param districtName - Display name from Stockholms stad geographic area
 */
export function buildDistrictFaqItems(districtName: string): DistrictFaqItem[] {
  return [
    {
      question: `Hur väljer jag hemtjänst i ${districtName}?`,
      answer: `Jämför utförare som arbetar i ${districtName} utifrån kontakt, språk, kompetens och kvalitet från officiella källor. Spara upp till tre utförare och använd vår checklista innan du bestämmer dig. Ditt val gör du via Stockholms stads kundval.`,
    },
    {
      question: `Betyder listan att utföraren kan ta emot mig i ${districtName} just nu?`,
      answer: `Nej. Att en utförare finns med i ${districtName} betyder att de är godkända att arbeta där enligt staden — inte att de har plats eller kan börja på dina tider. Fråga alltid utföraren om kapacitet innan du väljer.`,
    },
    {
      question: "Hur ansöker jag om hemtjänst i Stockholm?",
      answer:
        "Kontakta Stockholms stad för biståndsutredning och beslut. När du har ett beslut kan du välja utförare i kundvalet. Läs vår guide om att ansöka, och följ alltid stadens aktuella instruktioner.",
    },
    {
      question: "Hur jämför jag några utförare innan jag kontaktar dem?",
      answer:
        "Spara upp till tre utförare från listan och öppna jämförelsen. Ta med frågor från checklistan (starttid, kontinuitet, språk) när du ringer eller skriver.",
    },
    {
      question: `Kan jag byta hemtjänst om jag redan har utförare i ${districtName}?`,
      answer: `Ja, i Stockholms kundval kan du byta utförare enligt stadens regler. Läs guiden om att byta och kontrollera alltid aktuella steg hos Stockholms stad innan du byter.`,
    },
  ];
}

/**
 * Primary stadsdel label for provider SERP titles when areas are known.
 * Uses the first non-empty geographic area from the Stockholm presence payload.
 * @param geographicAreas - Areas from provider presence
 */
export function primaryDistrictLabel(
  geographicAreas: readonly string[] | null | undefined,
): string | null {
  for (const area of geographicAreas ?? []) {
    const trimmed = area.trim();
    if (trimmed.length > 0) return trimmed;
  }
  return null;
}
